module.exports = __webpack_public_path__ + "img/sosmed-instagram.c1353b10.png";